import type { TerrainStyle } from './terrain';

/** Svět (typ mapy): vzhled a fyzika. */
export interface WorldDef {
  style: TerrainStyle;
  name: string;
  icon: string;
  /** Násobek pozemské gravitace. */
  gravity: number;
  /** Násobek síly větru (0 = bez atmosféry). */
  wind: number;
}

/**
 * Gravitace není fyzikálně přesná (Měsíc 1/6, Mars 0,38) – s ní by střely
 * létaly daleko za mapu. Poměr je zachovaný, jen zmírněný kvůli hratelnosti.
 */
export const WORLDS: Record<TerrainStyle, WorldDef> = {
  hills: { style: 'hills', name: 'Kopce', icon: '⛰️', gravity: 1, wind: 1 },
  caves: { style: 'caves', name: 'Jeskyně', icon: '🦇', gravity: 1, wind: 1 },
  moon: { style: 'moon', name: 'Měsíc', icon: '🌙', gravity: 0.45, wind: 0 },
  mars: { style: 'mars', name: 'Mars', icon: '🔴', gravity: 0.65, wind: 1.35 },
};

export const TERRAIN_STYLES = Object.keys(WORLDS) as TerrainStyle[];

export function isTerrainStyle(v: unknown): v is TerrainStyle {
  return typeof v === 'string' && v in WORLDS;
}
